var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgByReceiver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9971 5.10015L16 10.6788V10.9235C16 13.6109 14.3709 15.2 11.6138 15.2H4.38685C1.62915 15.2 0 13.6109 0 10.9235V5.07034C0 2.38294 1.62915 0.800049 4.38685 0.800049H11.611C14.368 0.800049 15.9971 2.38294 15.9971 5.07034V5.10015Z",
    fill: "#C6E1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3788 5.74011C10.3788 7.14987 9.24884 8.28027 7.8386 8.28027C6.42884 8.28027 5.29844 7.14987 5.29844 5.74011C5.29844 4.33035 6.42884 3.19995 7.8386 3.19995C9.24884 3.19995 10.3788 4.33035 10.3788 5.74011ZM4 11.1559C4 9.85028 5.76832 9.52388 7.83856 9.52388C9.92032 9.52388 11.6771 9.8618 11.6771 11.1679C11.6771 12.474 9.9088 12.7999 7.83856 12.7999C5.75728 12.7999 4 12.462 4 11.1559Z",
    fill: "#3694FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgByReceiver);
export default __webpack_public_path__ + "static/media/by_receiver.750c4614119a7018d00684267ff1ca78.svg";
export { ForwardRef as ReactComponent };